// extracted by mini-css-extract-plugin
export default {"noProjectMessage":"Home_noProjectMessage__VkPwW","errorContainer":"Home_errorContainer__fr5lA Home_noProjectMessage__VkPwW"};